import { Header, Table } from 'semantic-ui-react';

function TotalStatsTable({ totalClicks, totalKeystrokes, middleDuration }) {
    return (
        <>
            <Header textAlign="center">Totals</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Clicks</Table.HeaderCell>
                        <Table.HeaderCell>Keystrokes</Table.HeaderCell>
                        <Table.HeaderCell>Middle Duration</Table.HeaderCell>
                        <Table.HeaderCell>Keystrokes + Clicks</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{totalClicks}</Table.Cell>
                        <Table.Cell>{totalKeystrokes}</Table.Cell>
                        <Table.Cell>{middleDuration}</Table.Cell>
                        <Table.Cell>{totalClicks + totalKeystrokes}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </>
    );
}

export default TotalStatsTable;
